import { CheckIcon } from 'lucide-react'
import { Checkbox as CheckboxPrimitive } from 'radix-ui'
import * as React from 'react'

import { cn } from '@/lib/utils'

const CHECKBOX_CLASS =
  'peer relative flex size-4 shrink-0 items-center justify-center rounded-[4px] border border-input transition-shadow outline-none group-has-disabled/field:opacity-50 after:absolute after:-inset-x-3 after:-inset-y-3.5 focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-2 aria-invalid:ring-destructive/20 aria-invalid:aria-checked:border-primary dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground dark:data-checked:bg-primary'

const INDICATOR_CLASS =
  'grid place-content-center text-current transition-none [&>svg]:size-3.5'

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot='checkbox'
      className={cn(CHECKBOX_CLASS, className)}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot='checkbox-indicator'
        className={INDICATOR_CLASS}
      >
        <CheckIcon />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

// Avoid hidden form inputs bubbling synthetic clicks into a clickable ancestor.
function CheckboxDisplay({
  checked = false,
  className,
  ...props
}: { checked?: boolean } & React.ComponentProps<'span'>) {
  return (
    <span
      data-slot='checkbox'
      data-state={checked ? 'checked' : 'unchecked'}
      data-checked={checked ? '' : undefined}
      aria-hidden
      className={cn(CHECKBOX_CLASS, className)}
      {...props}
    >
      {checked ? (
        <span data-slot='checkbox-indicator' className={INDICATOR_CLASS}>
          <CheckIcon />
        </span>
      ) : null}
    </span>
  )
}

export { Checkbox, CheckboxDisplay }
